import {EventBus} from "./event-bus";
import ShowNotification from "./show-notification";


export default {
    mixins: [ShowNotification],
    props: {
        report_id: Number,
        pdf_name: String,
        generate_route: String,
        export_route: String,
        export_excel_route: String,
        reports_list_route: String,
        all_reports_id: Object,
        project_badge_prefix: String,
    },
    data() {
        return {
            validForm: false,
            showTable: false,
            pagination: [],
            //elements: [],
            formData: null,
            paramsTrigger: 0
        }
    },
    methods: {
        generate(page, reportID) {
            EventBus.$emit('showLoader');
            let genBtn = event.currentTarget;
            genBtn.disabled = true;
            let form = document.getElementById('reportForm');
            this.formData = new FormData(form);
            this.formData.append('page', page)
            let self = this;
            axios({
                method: 'post',
                url: self.generate_route,
                data: self.formData
            })
                .then(function (response) {
                    self.showTable = true;
                    self.pagination = response.data[0];
                    switch (reportID) {
                        case self.all_reports_id.TASKS_BY_CLIENT:
                            self.statusesCounter = response.data[1];
                            self.criteriaCounter = response.data[2];
                            self.withComments    = response.data[3];
                            break;
                        case self.all_reports_id.TASKS_BY_CRITERION:
                            self.criteionCounter = response.data[1];
                            break;
                        case self.all_reports_id.TASKS_BY_MODULE:
                            self.modulesCounter = response.data[1];
                            break;
                        case self.all_reports_id.TASKS_BY_STATUS:
                            self.statusesCounter = response.data[1];
                            break;
                        case self.all_reports_id.TASKS_BY_VERSION:
                            break;
                        case self.all_reports_id.REACTION_TIME:
                            self.criteriaCounter = response.data[1];
                            self.totalAvg = response.data[2];
                            break;
                        case self.all_reports_id.SHIFT_SUMMARY:
                            self.statusesCounter = response.data[1];
                            self.selectedPeople = response.data[2];
                            break;
                        case self.all_reports_id.TASKS_WITH_STATUS:
                            self.statuses = response.data[1];
                            break;
                        case self.all_reports_id.CLOSED_TASKS_IN_PERIOD:
                            self.statuses = response.data[1];
                            break;
                        case self.all_reports_id.CONSULTANTS_AND_SYSTEM_ENGINEERS:
                            self.statuses = response.data[1];
                            break;
                        case self.all_reports_id.PENDING_TASKS:
                            self.statuses = response.data[1];
                            break;
                        case self.all_reports_id.COMPARISON_JIRA_SOS_STATUSES:
                            break;
                        case self.all_reports_id.LIBRARIES_BY_VERSION:
                            self.active = response.data[1];
                            self.saas = response.data[2];
                            break;
                        case self.all_reports_id.MAINTENANCE_SERVICE_SUMMARY:
                            self.countTimeForAll = response.data[1];
                            self.criteriaWithoutTasks = response.data[2];
                            break;
                        case self.all_reports_id.TASK_FEEDBACK:
                            self.statistics = response.data[1];
                            self.withComment = response.data[2];
                            break;
                        case self.all_reports_id.DORA:
                            break;
                        case self.all_reports_id.DETAILED_TASKS_CREATED_IN_PERIOD:
                            break;
                    }
                    self.paramsTrigger++;
                })
                .then(function () {
                    document.getElementById("reportTable").scrollIntoView();
                })
                .catch(function () {
                    self.showNotification("error", self.$lang("Nie udało się wygenerować raportu"));
                })
                .finally(function () {
                    genBtn.disabled = false;
                    EventBus.$emit('hideLoader');
                })
        },
        validation(isValid) {
            this.validForm = isValid;
        },
        hasData() {
            if (this.pagination.data !== undefined) {
                if (this.pagination.data.length > 0) {
                    return true;
                }
            }
            return false;
        },
        exportPDF() {
            $("#generatingModal").modal('show');
            let self = this;
            axios({
                method: 'post',
                url: self.export_route,
                data: this.formData,
                responseType: 'blob'
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    // works in IE11
                    if (typeof window.navigator.msSaveBlob === 'function') {
                        window.navigator.msSaveBlob(
                            response.data,
                            self.pdf_name + '.pdf'
                        );
                    } else {
                        link.setAttribute('download', self.pdf_name + '.pdf');
                        document.body.appendChild(link);
                        link.click();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function () {
                    setTimeout(function () {
                        $("#generatingModal").modal('hide');
                    }, 250, this);
                });
        },
        exportExcel(formData) {
            $("#generatingModal").modal('show');
            let self = this;
            axios({
                method: 'post',
                url: self.export_excel_route,
                data: this.formData || formData,
                responseType: 'blob'
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    // works in IE11
                    if (typeof window.navigator.msSaveBlob === 'function') {
                        window.navigator.msSaveBlob(
                            response.data,
                            self.pdf_name + '.xlsx'
                        );
                    } else {
                        link.setAttribute('download', self.pdf_name + '.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    }
                })
                .catch(function (error) {
                    self.showNotification("error", self.$lang("Nie udało się wygenerować raportu"));
                    console.log(error);
                })
                .finally(function () {
                    setTimeout(function () {
                        $("#generatingModal").modal('hide');
                    }, 250, this);
                });
        },
        setEventBusListenerPages() {
            EventBus.$on('changePage', ({value}) => {
                this.generate(value);
            });
        },
        sortElements(elements) {
            return _.orderBy(elements, 'name', 'asc');
        }
    },
    created() {
        this.setEventBusListenerPages();
    }
}
